import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChevronDown from "../../UI/ChevronDown";

import LetterX from "../../UI/LetterX";
import AutoCompleteDiagnostico from "../../UI/AutoCompleteDiagnostico";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
} from "@material-ui/core";
import { updateRecetaValues } from "../../../../actions/recetasDigitales/RecetasDigitales";

export const RecetasDigitalesAccordionDiagnostico = (props) => {
  const dispatch = useDispatch();
  const autoCompleteRef = useRef(null);

  const { recetaSeleccionada = {}} = useSelector(
    (state) => state.recetasDigitales
  );

  let diagnosticoReceta = null;

  if (recetaSeleccionada.diagnostico) {
    diagnosticoReceta = recetaSeleccionada.diagnostico;
  }

  const [diagnostico, setDiagnostico] =  useState(diagnosticoReceta);
  const [autoCompleteValue] = useState(null);

  const changeDiagnosticoHandler = (value) => {
    setDiagnostico(value);
    dispatch(
      updateRecetaValues({
        diagnostico: value,
        idDiagnostico: value ? value.idProblema : null,
      })
    );
  };

  useEffect(() => {
    props.setDatosCompletos(!!diagnostico);
  }, [diagnostico]);

  return (
    <Accordion TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary expandIcon={<ChevronDown />}>
        <Typography variant="h6">
          Diagnóstico{/*props.datosCompletos ? <CheckCircle /> : <AlertCircle />*/}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid
          container
          spacing={3}
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "0.5rem",
          }}
        >
          {!diagnostico && (
            <Grid item xs={11}>
              <AutoCompleteDiagnostico
                ref={autoCompleteRef}
                autoCompleteValue={autoCompleteValue}
                label="Diagnóstico"
                onChangeHandler={changeDiagnosticoHandler}
              />
            </Grid>
          )}
          {!!diagnostico && (
            <Grid item xs={11}>
              <Typography
                style={{
                  color: "#68389F",
                  width: "-webkit-fill-available",
                  fontSize: "1rem",
                  fontWeight: "bold",
                  fontStyle: "italic",
                  postion: "relative",
                }}
              >
                {diagnostico.problema}
                <LetterX deleteFunction={() => {setDiagnostico(null)}} styles={{ position: "absolute", marginLeft: "0.5rem", cursor: "pointer" }}/>
              </Typography>
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
